// import { useTranslation } from "react-i18next";

export const WorkHours = () => {
  // const { t } = useTranslation();

  return <div>Hello 👋, I am a WorkHours component.</div>;
};
